import { RouterStateSnapshot } from '@angular/router';

import { PageNotFoundPage } from './page-not-found.page';

/**
 * Whether the router landed on the not-found page. It renders at whatever address was asked for, so an address that
 * starts like a real section (`/dashboard/old-link`) must not be read as that section: the app picks its chrome
 * (header, sidebar footer) from the URL, and would otherwise frame the not-found page as a dashboard page.
 */
export const isPageNotFound = (state: RouterStateSnapshot): boolean => {
  let route = state.root;
  while (route.firstChild) route = route.firstChild;
  return route.component === PageNotFoundPage;
};
